// src/components/PurchaseFlow/Steps/ConfirmationViews/Variant1SuccessView.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCheck, 
  faHome,
  faFileAlt
} from '@fortawesome/free-solid-svg-icons';
import ActivationPendingSuccess from './ActivationPendingSuccess';

const Variant1SuccessView = ({ 
  confirmationSummary,
  onViewDetail,
  onCloseToSales,
  activationOutcome = 'completed'
}) => {
  if (activationOutcome === 'pending') {
    return <ActivationPendingSuccess onCloseToSales={onCloseToSales} />;
  }

  return (
    <div className="rg-sale-success-view">
      {/* Header con ícono de éxito */}
      <div className="text-center my-4 border-bottom pb-4">
        <div className="stepper-success-icon">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <h2 className="rg-sale-step__title rg-sale-step__title--success">Préstamo generado con éxito!</h2>
        <p>El préstamo ha sido aprobado y generado correctamente.</p>
      </div>

      {/* Botones de navegación */}
      <div className="text-center mt-4">
        <div className="row g-2 justify-content-center">
          <div className="col-md-4">
            <button 
              className="btn btn-light-secondary w-100"
              onClick={() => window.location.href = '/'}
            >
              <FontAwesomeIcon icon={faHome} className="me-2" />
              Volver al Inicio
            </button>
          </div>
          <div className="col-md-4">
            <button 
              className="btn btn-primary w-100"
              onClick={onViewDetail}
            >
              <FontAwesomeIcon icon={faFileAlt} className="me-2" />
              Ver Detalle de Venta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Variant1SuccessView;
